import type { ActivationGroup } from '@/features/activationGroup/types'
import PriceDataGrid from '@/features/bidding/components/price/offer/PriceDataGrid'
import { BidType } from '@/features/bidding/constants'
import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'
import type { AggregatedBid } from '@/features/bidding/utils/model/buildAggregatedBid'
import type { AggregatedBidWrapper } from '@/features/bidding/utils/model/mapActivationGroupBidsToAggregatedBids'
import {
  isPriceAreaAggregatedPartner,
  isSinglePriceStepPartner,
} from '@/features/bidding/utils/validation/priceStepValidationUtils'

export type ActivationGroupBidUpdate = {
  activationGroup: ActivationGroup
  aggregatedBid: AggregatedBid
}

type Props = {
  activationGroup: ActivationGroup
  bidsPerActivationGroup: Map<string, AggregatedBidWrapper>
  groupParams: GroupedBidParams
  hasAlreadyBidsForTheDay?: boolean
  onBidForActivationGroupUpdated: (update: ActivationGroupBidUpdate) => void
}

const PriceDataGridForActivationGroup = ({
  activationGroup,
  bidsPerActivationGroup,
  groupParams,
  hasAlreadyBidsForTheDay = false,
  onBidForActivationGroupUpdated,
}: Props) => {
  const setAggregatedBid = (newAggregatedBid: AggregatedBid) => {
    onBidForActivationGroupUpdated({
      activationGroup,
      aggregatedBid: newAggregatedBid,
    })
  }

  const { partnerCode } = activationGroup.portfolio
  const aggregatedBid = bidsPerActivationGroup.get(activationGroup.uuid)!.aggregatedBid

  return (
    <>
      {aggregatedBid.ptus.length > 0 && (
        <PriceDataGrid
          activationGroupUuids={[activationGroup.uuid]}
          aggregatedBid={aggregatedBid}
          bidsPerActivationGroup={bidsPerActivationGroup}
          enforcesSamePriceAcrossActivationGroups={
            isPriceAreaAggregatedPartner(partnerCode) && groupParams.bidType === BidType.CAPACITY
          }
          enforcesSinglePriceStep={isSinglePriceStepPartner(partnerCode)}
          groupParams={groupParams}
          hasAlreadyBidsForTheDay={hasAlreadyBidsForTheDay}
          isLoading={false}
          onAggregatedBidChange={setAggregatedBid}
        />
      )}
    </>
  )
}

export default PriceDataGridForActivationGroup
